<template>
  <div v-if="visible" class="popup-overlay">
    <div class="popup-card">
      <div class="popup-header-gradient">
        <button class="close-btn" @click="closePopup">&times;</button>
        <div class="header-content">
          <!-- <span class="butterflies">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="6" cy="6" r="4" fill="#F8BBD0"/><circle cx="18" cy="6" r="2.5" fill="#B2DFDB"/><circle cx="12" cy="12" r="1.5" fill="#FFF59D"/></svg>
          </span> -->
          <!-- <span class="spring-text">Spring</span> -->
          <span class="big-bundle-text my-4">{{events.update_note}}</span>
        </div>
        <!-- <div class="discount-row">
          <span class="get-up-to">Get up to</span>
          <span class="discount-pill">{{ discount }}</span>
        </div> -->
        <div>
            <ul
              class="text-black text-left mx-3 mb-2 px-3"
              style="color:rgb(10 0 0) !important;"
            >
              <li v-for="(line, idx) in (events?.description || '').split(/\r?\n/)" :key="idx">
                {{ line }}
              </li>
            </ul>
        </div>
        <!-- <div class="images-row">
          <img class="placeholder-img" src="http://api-sg8.nuxtgen.com/media/others_prodcut/Screenshot_143.png"  />
          <img class="placeholder-img" src="http://api-sg8.nuxtgen.com/media/others_prodcut/Screenshot_181.png"  />
          <img class="placeholder-img" src="http://api-sg8.nuxtgen.com/media/others_prodcut/Screenshot_173.png"  />
        </div> -->
      </div>
      <div class="popup-bottom">
        <!-- <div class="countdown-row">
          <div class="countdown-item" v-for="(val, label) in countdownLabels" :key="label">
            <div class="countdown-value">{{ countdown[label] }}</div>
            <div class="countdown-label">{{ val }}</div>
          </div>
        </div>
        <div class="popup-desc px-3">
          Purchase bundle at almost the <b>same price</b> as a single product
        </div> -->
        <div class="popup-actions">
          <a :href="events.target_link" class="btn btn-success mt-3 text-decoration-none" target="_blank" >
            Show Report 🚀
          </a>
          
          <!-- <button class="no-btn" @click="closePopup">No thanks I don't want to save</button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useSearchApi } from "../services/search.service";
import getProfileCheck from "@/services/check-profile.service";
export default {
  name: 'SpringBundlePopup',
  props: {
    discount: {
      type: String,
      default: '90% OFF',
    },
    // Add more props as needed for reusability
  },
  data() {
    return {
      visible: null,
      events: [],
      countdown: {
        days: '05',
        hours: '16',
        minutes: '58',
        seconds: '22',
      },
      countdownLabels: {
        days: 'Day',
        hours: 'Hr',
        minutes: 'Min',
        seconds: 'Sec',
      },
      intervalId: null,
      endTime: null,
    };
  },
  async mounted()  {
    // Always show on reload
    const response = await getProfileCheck.getProfileCheck();
    this.visible = response?.is_active_event || false;
    this.getEvents();
    // Set countdown end time (e.g., 5 days from now)
    this.endTime = new Date(Date.now() + 5 * 24 * 60 * 60 * 1000);
    this.updateCountdown();
    this.intervalId = setInterval(this.updateCountdown, 1000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  methods: {

    async getEvents() {
      this.data = await useSearchApi().getDiscountList();
      this.events = this.data;
    },

    async closePopup() {
      await useSearchApi().updateDiscountList();
      this.visible = false;
    },
    updateCountdown() {
      const now = new Date();
      const distance = this.endTime - now;
      if (distance < 0) {
        this.countdown = { days: '00', hours: '00', minutes: '00', seconds: '00' };
        clearInterval(this.intervalId);
        return;
      }
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      this.countdown = {
        days: String(days).padStart(2, '0'),
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      };
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  bottom: 0;
  right: 0;
  left: auto;
  top: auto;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 9999;
}
.popup-card {
  pointer-events: all;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(44,62,80,0.18), 0 2px 8px rgba(44,62,80,0.10);
  padding: 0 0 8px 0;
  width: 360px;
  max-width: 98vw;
  position: absolute;
  bottom: 24px;
  right: 24px;
  text-align: center;
  overflow: hidden;
}
.popup-header-gradient {
  background: linear-gradient(120deg, #e3f0ff 0%, #fbeee6 100%);
  padding: 0 0 12px 0;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  position: relative;
}
.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: #fff;
  border: none;
  font-size: 1.2rem;
  color: #bdbdbd;
  cursor: pointer;
  z-index: 2;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  box-shadow: 0 2px 8px rgba(44,62,80,0.10);
  transition: background 0.2s;
}
.close-btn:hover {
  background: #f3e7e9;
}
.header-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 22px;
  padding-bottom: 2px;
}
.butterflies {
  margin-right: 2px;
  display: flex;
  align-items: center;
}
.spring-text {
  color: #929797 !important;
  font-family: 'Pacifico', cursive;
  font-size: 1.3rem;
  font-weight: 700;
  margin-right: 2px;
  letter-spacing: -0.5px;
}
.big-bundle-text {
  color: #929797 !important;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: -0.5px;
  text-align: center;
}
.discount-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 10px;
  margin-top: 2px;
}
.get-up-to {
  color: #020203 !important;
  font-size: 0.98rem;
  font-weight: 700;
  letter-spacing: -0.2px;
}
.discount-pill {
  background: #ff3366;
  color: #fff !important;
  border-radius: 14px;
  padding: 5px 16px;
  font-size: 0.98rem;
  font-weight: 900;
  box-shadow: 0 2px 8px rgba(44,62,80,0.10);
  margin-left: 2px;
  letter-spacing: 0.2px;
}
.images-row {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 0;
  margin-top: 8px;
  padding: 0 8px 0 8px;
}
.placeholder-img {
  width: 120px;
  height: 140px;
  border-radius: 8px;
  display: inline-block;
  box-shadow: 0 2px 8px rgba(44,62,80,0.08);
  object-fit: cover;
  background: #f8fafc;
}
.popup-bottom {
  background: #fff;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 0 0 0 0;
}
.countdown-row {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
  margin-top: 14px;
}
.countdown-item {
  background: #fff3f7;
  border-radius: 10px;
  padding: 10px 8px 6px 8px;
  min-width: 56px;
  box-shadow: 0 1px 4px rgba(44,62,80,0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.countdown-value {
  font-size: 1.18rem;
  font-weight: 900;
  color: #1a2a36;
  margin-bottom: 2px;
  letter-spacing: 0.5px;
}
.countdown-label {
  font-size: 0.85rem;
  color: #a0a0a0;
  font-weight: 700;
  letter-spacing: 0.2px;
}
.popup-desc {
  margin-bottom: 14px;
  color: #1a2a36;
  font-size: 0.98rem;
  margin-top: 2px;
  font-weight: 500;
  letter-spacing: 0.05px;
}
.popup-desc b {
  font-weight: 900;
  font-size: 1.08em;
  color: #1a2a36;
}
.popup-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0 12px 12px 12px;
}
.yes-btn {
  background: linear-gradient(90deg, #4f8cff 0%, #ff6a6a 100%);
  color: #fff;
  border: none;
  border-radius: 14px;
  padding: 10px 0;
  font-size: 1rem;
  font-weight: 800;
  cursor: pointer;
  margin-bottom: 2px;
  box-shadow: 0 1px 4px rgba(44,62,80,0.08);
  transition: background 0.2s;
  letter-spacing: 0.2px;
}
.yes-btn:hover {
  background: linear-gradient(90deg, #ff6a6a 0%, #4f8cff 100%);
}
.no-btn {
  background: none;
  color: #858383;
  border: none !important;
  font-size: 0.92rem;
  cursor: pointer;
  margin-top: 0px;
  font-weight: 500;
  letter-spacing: 0.1px;
}
</style> 